export const parseTokenLifetimeInput = (value: string): number | undefined =>
  value === '' ? undefined : Number(value);

export const tokenLifetimeValidator = (tokenLifetime: string | undefined): string => {
  if (!tokenLifetime) {
    return 'app.validation.required';
  }

  const value = Number(tokenLifetime);

  if (Number.isNaN(value) || value < 60 || value > 1893456000) {
    return 'app.validation.value-invalid';
  }

  return '';
};
